// @ts-nocheck
/**
 * reportFiltersReducer — preserves the /reports/contractor-work filters across
 * navigations. Keyed by `reportId` ("1099" | "w2" | etc) so each tab has its
 * own state, the same way dashboardFiltersReducer did for dashboards.
 *
 * Persisted to localStorage via persistConfig.whitelist in rootReducer.ts.
 *
 * State schema:
 *   filters: { [reportId]: { contractorValue, state, eventValue, startDate, endDate } }
 */
import {
  UPDATE_REPORT_FILTERS,
  RESET_REPORT_FILTERS,
} from "../constants/reportFilters";

export const initialState = {
  filters: {
    /** Default tab — Contractor Work 1099 */
    "1099": {
      contractorValue: "",
      state: "",
      eventValue: "",
      startDate: "",
      endDate: "",
    },
    /** Tab Contractor Work W2 */
    w2: {
      contractorValue: "",
      state: "",
      eventValue: "",
      startDate: "",
      endDate: "",
    },
  },
};

const reportFiltersReducer = (state = initialState, action) => {
  switch (action?.type) {
    case UPDATE_REPORT_FILTERS: {
      const { reportId, values } = action.payload || {};
      if (!reportId) return state;
      return {
        ...state,
        filters: {
          ...state.filters,
          [reportId]: {
            ...(state.filters?.[reportId] || {}),
            ...(values || {}),
          },
        },
      };
    }
    case RESET_REPORT_FILTERS: {
      const reportId = action.payload?.reportId;
      if (!reportId) return initialState;
      return {
        ...state,
        filters: {
          ...state.filters,
          [reportId]: initialState.filters[reportId] || {
            contractorValue: "",
            state: "",
            eventValue: "",
            startDate: "",
            endDate: "",
          },
        },
      };
    }
    default:
      return state;
  }
};

export default reportFiltersReducer;
